import Icon from './Icon.tsx';
import { ComposedIconProps } from './Icon.tsx';
import url from '@/assets/images/arrow_down.svg';

const ArrowDownIcon = ({ icon = url, ...rest }: ComposedIconProps) => {
  return <Icon icon={icon} {...rest} />;
};

export default ArrowDownIcon;
